var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.947,5.029h-4.47V4.265C16.478,3.016,15.381,2,14.033,2H9.688C8.339,2,7.243,3.016,7.243,4.265v0.764h-4.19 c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75H4.12v13.026C4.12,20.903,5.217,22,6.565,22h10.683 c1.349,0,2.445-1.097,2.445-2.445V6.529h1.254c0.414,0,0.75-0.336,0.75-0.75S21.361,5.029,20.947,5.029z M8.743,4.265 C8.743,3.85,9.175,3.5,9.688,3.5h4.346c0.512,0,0.944,0.35,0.944,0.765v0.764H8.743V4.265z M18.193,19.555 c0,0.521-0.424,0.945-0.945,0.945H6.565c-0.521,0-0.945-0.424-0.945-0.945V6.529h12.573V19.555z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.373,9.742c-0.414,0-0.75,0.336-0.75,0.75v5.958c0,0.414,0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75v-5.958 C9.123,10.078,8.787,9.742,8.373,9.742z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.907,9.785c-0.414,0-0.75,0.336-0.75,0.75v5.958c0,0.414,0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75v-5.958 C12.656,10.121,12.321,9.785,11.907,9.785z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.729,10.489v5.958c0,0.414,0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75v-5.958c0-0.414-0.336-0.75-0.75-0.75 S14.729,10.075,14.729,10.489z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.001bf8b2e5657df7f78955ceca04cb7e.svg";
export { ForwardRef as ReactComponent };